import { Box } from '@mui/material';
import { Stepper } from '@nrdy-marketing-engine/stepper';
import LogoNavbar from './logo-navbar';

function StepperNavbar({ activeStep, totalSteps }: { activeStep: number; totalSteps: number }) {
  return (
    <LogoNavbar>
      <Box display="flex" flex={1} justifyContent="center" marginRight="44px" width="100%">
        <Stepper initialStep={activeStep} initialTotalSteps={totalSteps} />
      </Box>
    </LogoNavbar>
  );
}

export default StepperNavbar;
